import { render } from "./BoardRight.vue?vue&type=template&id=6c86cdac&scoped=true"
import script from "./BoardRight.vue?vue&type=script&lang=js"
export * from "./BoardRight.vue?vue&type=script&lang=js"

import "./BoardRight.vue?vue&type=style&index=0&id=6c86cdac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c86cdac"]])

export default __exports__